<template>
    <vxe-modal
        v-model="visible"
        title="执行频次变更审核"
        :width="860"
        :height="600"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formData"
                :rules="formRules"
                title-align="right"
                ref="rFormChange"
                title-width="60"
            >
                <vxe-form-item
                    title="开发编号"
                    field="ProcessID"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formData.ProcessID"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="数字员工名称"
                    field="ProcessName"
                    span="12"
                    title-width="130px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formData.ProcessName"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="原人工每次耗时"
                    field="oldManSingleTime"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            v-model="formData.oldManSingleTime"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="新人工每次耗时"
                    field="ManSingleTime"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formData.ManSingleTime"
                            placeholder="请输入新人工每次耗时"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="原人工每月次数"
                    field="oldManFrequency"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            v-model="formData.oldManFrequency"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="新人工每月次数"
                    field="ManFrequency"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formData.ManFrequency"
                            placeholder="请输入新人工每月次数"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="原开发时长"
                    field="oldDevelopTime"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            v-model="formData.oldDevelopTime"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="新开发时长"
                    field="DevelopTime"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formData.DevelopTime"
                            placeholder="请输入新开发时长"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="原机器人单次耗时"
                    field="oldRobotSingleTime"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            v-model="formData.oldRobotSingleTime"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="新机器人单次耗时"
                    field="RobotSingleTime"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formData.RobotSingleTime"
                            placeholder="请输入新机器人单次耗时"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="原机器人每月次数"
                    field="oldRobotMonthRun"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            v-model="formData.oldRobotMonthRun"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="新机器人每月次数"
                    field="RobotMonthRun"
                    span="12"
                    title-width="160px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formData.RobotMonthRun"
                            placeholder="请输入新机器人每月次数"
                            :disabled="allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="变更原因"
                    field="changeReason"
                    span="24"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-textarea
                            rows="4"
                            v-model="formData.changeReason"
                            placeholder="请输入变更原因"
                            maxlength="1000"
                            show-word-count
                            :disabled="allInputDisable"
                        ></vxe-textarea>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    span="24"
                    title-align="left"
                    title-width="600px"
                    :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                >
                    <template #title>
                        <span style="color: red">审核意见</span>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="24">
                    <template #default>
                        <vxe-textarea
                            rows="4"
                            v-model="auditOpinion"
                            placeholder="请输入审核意见"
                            maxlength="1000"
                            show-word-count
                        ></vxe-textarea>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer v-if="activeKey === '1'">
            <div align="center" span="24">
                <vxe-button @click="reject" icon="fa fa-reply" status="danger">
                    驳回
                </vxe-button>

                <vxe-button
                    :loading="submitting"
                    @click="submit"
                    icon="fa fa-check"
                    status="success"
                >
                    通过
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal
        title="审核记录"
        v-model="isShowAuditList"
        width="500"
        height="600"
    >
        <template #default>
            <div>
                <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import MyAuditLine from "../myPlug/MyAuditLine";
import {
    ref,
    reactive,
    defineExpose,
    defineEmits,
    defineProps,
    getCurrentInstance,
    onMounted,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
const emit = defineEmits(["flashData"]);
const { proxy } = getCurrentInstance();
const activeKey = ref("1");
const submitting = ref(false);
const allInputDisable = ref(true);
const rFormChange = ref();
const historyData = ref([]);

const formData = reactive(getEmptyFormData());
const visible = ref(false);
const isShowAuditList = ref(false);
const dtAudit = ref([]);
const formRules = {
    ManSingleTime: [{ required: true, message: "请输入新人工每次耗时" }],
    ManFrequency: [{ required: true, message: "请输入新人工每月次数" }],
    DevelopTime: [{ required: true, message: "请输入新开发时长" }],
    RobotSingleTime: [{ required: true, message: "请输入新机器人单次耗时" }],
    RobotMonthRun: [{ required: true, message: "请输入新机器人每月次数" }],
    changeReason: [{ required: true, message: "请输入变更原因" }],
};
const auditOpinion = ref("OK");
function getEmptyFormData() {
    return {
        Id: "",
        pubId: "",

        ProcessID: "",
        ProcessName: "",
        DevelopUser: "",

        ManSingleTime: null,
        ManFrequency: null,
        DevelopTime: null,
        RobotSingleTime: null,
        RobotMonthRun: null,

        oldManSingleTime: null,
        oldManFrequency: null,
        oldDevelopTime: null,
        oldRobotSingleTime: null,
        oldRobotMonthRun: null,

        changeType: "1",
        status: "0",
        changeReason: "",
        creationTime: "",
        creator: "",
    };
}

async function reject() {
    if (auditOpinion.value === "OK") {
        VXETable.modal.message({
            content: "驳回请修改默认审核意见",
            status: "error",
        });
        return;
    }
    const type = await VXETable.modal.confirm("您确定要驳回吗?");

    if (type === "confirm") {
        const params = {
            Id: formData.Id,
            status: "3", //驳回 改回已审核
            auditMan: proxy.$store.state.userID,
        };
        proxy.$api.newPublishManageAPI
            .auditPublishInfoChange(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                const auditNode = "CoE审核";
                //审核记录
                addAuditRecord(formData.Id, "2", auditNode, auditOpinion.value);

                VXETable.modal.message({
                    content: "驳回成功",
                    status: "success",
                });
                visible.value = false;
                emit("flashData");
            })
            .catch((error) => {
                console.log(error);
            });
    }
}
function submit() {
    if (auditOpinion.value === "") {
        VXETable.modal.message({
            content: "审核意见不能为空",
            status: "error",
        });
        return;
    }

    const params = {
        Id: formData.Id,
        status: "2",
        auditMan: proxy.$store.state.userID,
    };
    proxy.$api.newPublishManageAPI
        .auditPublishInfoChange(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            const auditNode = "CoE审核";
            //审核记录
            addAuditRecord(formData.Id, "1", auditNode, auditOpinion.value);

            VXETable.modal.message({
                content: "审核成功",
                status: "success",
            });
            visible.value = false;
            emit("flashData");
        })
        .catch((error) => {
            console.log(error);
        });
}
function showAuditList(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [row.Id, "1"], //
    };
    proxy.$api.requireManageAPI
        .getAuditRecordList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtAudit.value = res.data.Data;
            isShowAuditList.value = true;
        })
        .catch((error) => {
            console.log(error);
        });
}
function audit(row) {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [row.Id],
    };
    proxy.$api.newPublishManageAPI
        .getPublishInfoChangeOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            console.log(res.data.Data);
            Object.assign(formData, res.data.Data);

            visible.value = true;
        })
        .catch((error) => {
            console.log(error);
        });
}

// function setHistory(row) {
//     const params = {
//         uid: proxy.$store.state.userID,
//         email: proxy.$store.state.email,
//         currentPage: 1,
//         pageSize: 50,
//         searchKey: [row.Id, "1"],
//     };
//     proxy.$api.newPublishManageAPI
//         .getPublishInfoChange(Qs.stringify(params))
//         .then((res) => {
//             if (res.data.Success == false) {
//                 console.log(res.data.Message);
//                 return;
//             }
//             // console.log(res.data.Data);
//             historyData.value = Array.isArray(res.data.Data.dataTable)
//                 ? res.data.Data.dataTable
//                 : [];
//         })
//         .catch((error) => {
//             console.log(error);
//         });
// }
const addAuditRecord = (bussId, status, auditNode, auditOpinion) => {
    //写审核日志
    const params = {
        auditBuId: bussId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //1 通过 2 驳回
        auditOpinion: auditOpinion,
        auditNode: auditNode,
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const getModel = () => {
    const data = new FormData();

    data.append("Id", formData.Id ?? "");
    data.append("pubId", formData.pubId ?? "");

    data.append("ProcessID", formData.ProcessID ?? "");
    data.append("ProcessName", formData.ProcessName ?? "");
    data.append("DevelopUser", formData.DevelopUser ?? "");

    data.append("ManSingleTime", formData.ManSingleTime ?? "");
    data.append("ManFrequency", formData.ManFrequency ?? "");
    data.append("DevelopTime", formData.DevelopTime ?? "");
    data.append("RobotSingleTime", formData.RobotSingleTime ?? "");
    data.append("RobotMonthRun", formData.RobotMonthRun ?? "");

    data.append("oldManSingleTime", formData.oldManSingleTime ?? "");
    data.append("oldManFrequency", formData.oldManFrequency ?? "");
    data.append("oldDevelopTime", formData.oldDevelopTime ?? "");
    data.append("oldRobotSingleTime", formData.oldRobotSingleTime ?? "");
    data.append("oldRobotMonthRun", formData.oldRobotMonthRun ?? "");

    data.append("changeType", formData.changeType ?? "");
    data.append("status", formData.status ?? "");
    data.append("changeReason", formData.changeReason ?? "");
    data.append("creationTime", formData.creationTime ?? "");
    data.append("creator", formData.creator ?? "");

    return data;
};

// onMounted(() => {
//     init();
// });

defineExpose({
    audit,
});
</script>

<style scoped>
.apply-page {
    padding: 16px;
    background: #fff;
}

.notice-text {
    color: red;
}
</style>
